export default {
  HolderModal: {
    position: 'absolute',
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    height: '60vh',
    width: '50%',
    backgroundColor: 'white',
    padding: '5px',
  },
  HolderModalMobile: {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    position: 'absolute',
    height: '80%',
    width: '84%',
    backgroundColor: 'white',
    padding: '0px',
    overflowY: 'auto',
  },
  modalCloseButtonMobile: {
    cursor: 'pointer',
    marginLeft: '90%',
    borderRadius: '50%',
    top: '0',
    marginTop: '5px',
    position: 'fixed',
    background: '#fff',
    color: '#666',
    textAlign: 'center',
  },
  modalCloseButton: {
    cursor: 'pointer',
    marginLeft: '90%',
    borderRadius: '50%',
    top: '0',
    marginTop: '20px',
    position: 'fixed',
    background: '#fff',
    color: '#666',
    textAlign: 'center',
  },

  headRow: {
    backgroundColor: 'black',
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'start',
    padding: 3,
    fontSize: '11px',
  },

  filerRow: {
    textAlign: 'start',
    padding: 3,
    fontSize: '14px',
  },
  filerRowMobile: {
    textAlign: 'start',
    padding: 3,
    fontSize: '11px',
  },
  ModalTable: {
    width: '92%',
    margin: 'auto',
    paddingTop: '10px',
  },
  tableDiv: {
    overflowY: 'scroll',
    margin: 'auto',
    width: '100%',
    maxHeight: 'calc(60vh - 60px)',
  },

  tableDivMobile: {
    overflowY: 'scroll',
    margin: 'auto',
    width: '100%',
    maxHeight: 'calc(70vh - 10px)',
  },
  boardModalTableContainerMobile: {
    width: '100%',
    overflowY: 'scroll',
    maxHeight: '250px',
    marginTop: '1%',
  },

  premiumdiv: {
    width: '100%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, 0)',
  },
};



// WEBPACK FOOTER //
// ./src/components/Modals/Holders Modal/HolderStyles.js